<template>
  <BasePage>
    <div class="columns is-desktop">
      <div class="column is-one-third is-offset-one-third">
        <h1 class="title is-1">Welcome to ClassForward!</h1>
        <section class="mt-4">
          <h3 class="title is-3">Finish activating your account</h3>

          <form action="" method="post" @submit.prevent="reset()">

            <div class="field">
              <label class="label">Password</label>
              <p class="control">
                <input
                  v-model="password"
                  class="input"
                  type="password"
                  placeholder="password"
                  required
                  />

                <p v-if="passwordTooShort" class="help is-danger">This password is too short (8 chars min)</p>
              </p>
            </div>

            <div class="field">
              <label class="label">Your School Name</label>
              <p class="control">
                <input
                  v-model="school"
                  class="input"
                  type="text"
                  required
                  />
              </p>
            </div>

            <div class="field">
              <p class="control">
                <button type='submit' class="button is-primary" :class="loading && 'is-loading'" :disabled="!valid">Activate</button>
              </p>
            </div>

          </form>

        </section>
      </div>
    </div>
  </BasePage>
</template>

<script>
import axios from 'axios'

import BasePage from './BasePage.vue'

import store from '../store'
export default {
  name: 'Activate',
  data () {
    return {
      token: this.$route.query.token,
      password: '',
      name: '',
      school: '',
      requirements: [],
      newPasswordErrors: [],
      loading: false,
    }
  },
  components: {
    BasePage,
  },
  methods: {
    reset () {
      const data = {
        token: this.token,
        password: this.password,
        school: this.school,
      }
      this.loading = true
      axios.post('/api/v1/activate/', data)
        .then(response => response.data.token)
        .then(token => {
          // TODO WIP This isn't hooked up
          store.commit('authenticateUser', { token })
          this.$router.push('/')
        })
        .catch(error => {
          console.log(error)
          if (error.response) {
            const data = error.response.data
            this.newPasswordErrors = data.password != null ? data.password : []

            const invalidToken = data.token
            if (invalidToken) {
              store.commit('notify', {
                message: 'Invalid Token. It has most likely expired.',
                level: 'danger',
                sticky: true,
              })
            }
          } else {
            // network error
            store.commit('notify', {
              message: 'Error contacting server. Are you connected to the internet?',
              level: 'danger',
              sticky: true,
            })
          }
        })
        .then(() => {
          this.loading = false
        })
    },
  },
  computed: {
    valid () {
      return this.password.length > 7
    },
    passwordTooShort () {
      return this.password.length < 8 && this.password.length > 0
    }

  },
}
</script>



// WEBPACK FOOTER //
// Activate.vue?d564f9a0